export const categoryState = {
  active: 'active',
  inactive: 'inactive',
};

export const tagState = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
};

export const postState = {
  draft: 'draft',
  published: 'published',
  scheduled: 'scheduled',
};
